import { ErrorHelper } from '@/helpers/ErrorHelper'
import { mapActions, mapGetters } from 'vuex'
import { SelectedSiteIdMixin } from '@/mixins/Booking/SelectedSiteIdMixin'

export const KioskSignInSettingCacheMixin = {
  mixins: [SelectedSiteIdMixin],
  data () {
    return {
      kioskSignInSettingError: ''
    }
  },
  computed: {
    ...mapGetters('KioskSignInSettings', ['findKioskSignInSetting']),
    kioskSignInSettingCache () {
      return this.findKioskSignInSetting(this.selectedSiteId)
    },
    fetchingKioskSignInSetting () {
      return !!this.kioskSignInSettingCache && this.kioskSignInSettingCache.loading
    },
    kioskSignInSetting () {
      return this.kioskSignInSettingCache ? this.kioskSignInSettingCache.value : null
    },
    kioskSignInSettingEnabled () {
      return !!this.kioskSignInSetting && !!this.kioskSignInSetting.enabled
    }
  },
  watch: {
    selectedSiteId () {
      this.refreshKioskSignInSetting()
    }
  },
  methods: {
    ...mapActions('KioskSignInSettings', ['fetchKioskSignInSetting']),
    refreshKioskSignInSetting () {
      if (!this.kioskSignInSettingCache || this.kioskSignInSettingCache.retry) {
        this.tryFetchKioskSignInSetting()
      }
    },
    tryFetchKioskSignInSetting () {
      const self = this
      self.kioskSignInSettingError = ''
      if (!self.selectedSiteId) return
      self.fetchKioskSignInSetting(self.selectedSiteId)
        .catch(error => { self.kioskSignInSettingError = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshKioskSignInSetting()
  }
}
